export const ERROR_HEADER = "Oops! Something went wrong. But don't fret!";
